module.exports = __webpack_public_path__ + "static/media/flowers_3.0b8794dd.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_3.csv
// module id = 760
// module chunks = 0